import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useAppRedirect } from '../hooks/useAppRedirect';

export const EventRedirectScreen = () => {
    const { t } = useTranslation();
    
    const { eventId } = useParams<{ eventId: string }>();

    useAppRedirect(`event/${eventId}`);

    return (
        <div style={{ textAlign: 'center', padding: '180px 20px', fontFamily: 'sans-serif' }}>
            <h2>{t('eventRedirect.title')}</h2>
            <p>{t('eventRedirect.description')}</p>
        </div>
    );
};